import React, { Fragment } from 'react';

import SectionSeparator from '@dashboard/components/SectionSeparator';

import useStepDefinitionsMutator from '../useStepDefinitionsMutator';

import DelaySection from './DelaySection';
import StepPanel from './StepPanel';

export default function StepsSection() {
  const { fields } = useStepDefinitionsMutator();
  return (
    <>
      <DelaySection />
      {fields.map((name, index) => (
        <Fragment key={`${name}.${fields.value.length}`}>
          <SectionSeparator />
          <StepPanel index={index} name={name} />
        </Fragment>
      ))}
    </>
  );
}
